import React from 'react';
import './Offer.css';



const Offer = ({ offer }) => {

  const { id, image, title, validUntil } = offer; // Extracting data from offer object

  const [before, percentage, after] = offer.discount.split(/(\d+%)/);

  return (
    <div key={id} className={`offer-item offer-${id}`} >
      <img src={image} alt={offer.title} />
      <div className="content">
        <h3>{title}</h3>
        <p className="discount">{before} <span>{percentage}</span> {after}</p>
        <p><span>Valid:</span> {validUntil}</p>
      </div>
    </div>
  );
};

export default Offer;